import React, { } from 'react'
import LocationPicker61 from './61/LocationPicker'
import LocationMap from './LocationMap'
import { geometry2feature, amersfoort2graden } from '../utils/location'
import { findPlot } from '../utils'

const LocationPicker = (props) => {

    return (
        <>
            {parseInt(process.env.REACT_APP_PROJECTID) === 46 ? <DefaultLocationPicker {...props} /> : null}
            {parseInt(process.env.REACT_APP_PROJECTID) === 56 ? <DefaultLocationPicker {...props} /> : null}
            {parseInt(process.env.REACT_APP_PROJECTID) === 57 ? <DefaultLocationPicker {...props} /> : null}
            {parseInt(process.env.REACT_APP_PROJECTID) === 58 ? <DefaultLocationPicker {...props} /> : null}
            {parseInt(process.env.REACT_APP_PROJECTID) === 61 ? <LocationPicker61 {...props} /> : null}
            {parseInt(process.env.REACT_APP_PROJECTID) === 62 ? <DefaultLocationPicker {...props} /> : null}
        </>
    )
}

const DefaultLocationPicker = ({ onSelect, plots, plot, setPlot }) => {
    const position= (plot === -1 ? amersfoort2graden(155000, 463000) : geometry2feature(findPlot(plots, plot).location.geometry).geometry.coordinates.reverse())
    const zoom = (plot === -1 ? 8 : 11)

    const handleSelect = (plotId) => {
        onSelect()
        setPlot(plotId, true)
    }
    return (
        <LocationMap onSelect={handleSelect} plots={plots} plot={plot}
            position={position} zoom={zoom} />
    )
}

export default LocationPicker
